export default "__VITE_ASSET__CmetbLbQ__"